import axios from 'axios';

export function addByGet(productId) {    
  axios
    .get(`/cart/${productId}/add.json`)
    .then(response =>{
      if(response.data.success === true){
        var notyf = new Notyf({
          position: {
            x: 'right',
            y: 'bottom',
          },
        });
        notyf.success('カート追加が完了しました！');
        const cartNums = document.getElementsByClassName('cart-amount');
        for (let i = 0; i < cartNums.length; i++) {          
          cartNums[i].style.display = 'inline-block';
          cartNums[i].textContent = response.data.cart_nums;
        }
      }else{
        var notyf = new Notyf({
          position: {
            x: 'right',
            y: 'bottom',
          },
        });
        notyf.error(response.data.message);      
      }
  });    

  return false;
}